export default "__VITE_PUBLIC_ASSET__c520bfd2__"